import { adminFetch } from "./_client";
import type { KycReviewRow, KycReviewDetail, KycReviewDetailResponse } from "./types";


export function listKycReviews(token: string, params: { status?: string; q?: string; limit?: number; offset?: number } = {}) {
  const sp = new URLSearchParams();
  if (params.status) sp.set("status", params.status);
  if (params.q) sp.set("q", params.q);
  if (params.limit) sp.set("limit", String(params.limit));
  if (params.offset) sp.set("offset", String(params.offset));
  const qs = sp.toString();
  return adminFetch<{ rows: KycReviewRow[]; total: number; limit: number; offset: number }>(`/admin/kyc-reviews${qs ? `?${qs}` : ""}`, token);
}

export function getKycReview(token: string, id: number) {
  return adminFetch<KycReviewDetailResponse>(`/admin/kyc-reviews/${id}`, token);
}

export function createKycReview(token: string, body: { user_id: string; reason?: string; notes?: string; source?: string }) {
  return adminFetch<{ review: KycReviewDetail }>(`/admin/kyc-reviews`, token, { method: "POST", body: JSON.stringify(body) });
}

export function decideKycReview(token: string, id: number, body: { decision: "approve" | "reject"; override_value?: boolean; reason?: string; notes?: string }) {
  return adminFetch<{ review: KycReviewDetail }>(`/admin/kyc-reviews/${id}/decide`, token, { method: "POST", body: JSON.stringify(body) });
}

export function attachKycReviewDocument(token: string, id: number, body: { storage_key?: string; filename?: string; mime_type?: string }) {
  return adminFetch<{ review: KycReviewDetail }>(`/admin/kyc-reviews/${id}/document`, token, { method: "POST", body: JSON.stringify(body) });
}

export function getDriverVerificationAdminDetail(token: string, driverId: number) {
  return adminFetch<{
    driver: Record<string, unknown>;
    verification?: {
      phase: string;
      assigned_driver_id: number;
      contexts: Array<Record<string, unknown>>;
      communications: Array<Record<string, unknown>>;
      manifests: Array<Record<string, unknown>>;
      evidence: { completeness: string; retention_hold: boolean; retention_hold_reason: string | null; purge_after: string | null };
    };
    audit_log: Array<Record<string, unknown>>;
  }>(`/admin/driver-verification/${driverId}`, token);
}

export function exportClaimDriverVerificationManifest(
  token: string,
  claimId: number,
  body: { purpose: string; reason: string },
) {
  return adminFetch<{ manifest: Record<string, unknown> }>(
    `/admin/claims/${claimId}/driver-verification-manifest`,
    token,
    { method: "POST", body: JSON.stringify(body) },
  );
}
